export default __webpack_public_path__ + "5a26b885543a987c39e78cc7c98bf925.png";